<template>
  <div class="main-container">
    <div class="page-top-title">
      <p class="title">{{ reportName }}</p>
      <div class="page-top-right">
        <div class="item">
          结算日期：
          <span class="num">{{ settlementDate }}</span>
        </div>

        <div class="item settlement-status">
          结算状态：
          <div v-if="detailData.settlementStatus == 0" class="tag-settled">待结算</div>
          <div v-else class="tag-be">已结算</div>
        </div>
      </div>
    </div>
    <div class="statistics-container">
      <p>汇总数据</p>
      <div class="statistics-item">
        <div class="item">
          保单数：
          <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
        </div>
        <div class="item">
          批单数：
          <span class="num">{{ statisticsObj.billNum || 0 }}</span>
        </div>
        <div class="item">
          保费合计：
          <span class="num">{{ statisticsObj.fee || 0 }}</span
          >元
        </div>
        <div class="item">
          基础费用合计：
          <span class="num" v-if="statisticsObj.baseFirstIncome && statisticsObj.baseFirstLeaderIncome">
            {{ (Number(statisticsObj.baseFirstIncome) + Number(statisticsObj.baseFirstLeaderIncome)).toFixed(2) }}
          </span>
          <span class="num" v-else>0</span>
          元
        </div>
        <div class="item">
          业务员基础费用合计：
          <span class="num">{{ statisticsObj.baseFirstIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          团队长管理费合计：
          <span class="num">{{ statisticsObj.baseFirstLeaderIncome || 0 }}</span
          >元
        </div>
      </div>
    </div>

    <Tabs v-model="tabVal" @on-click="clickTabs">
      <TabPane label="业务员明细" name="1"></TabPane>
      <TabPane label="按机构汇总" name="2"></TabPane>
    </Tabs>

    <div class="search-container" v-if="tabVal=='1'">
      <div class="search-box min">
        <div class="input-item">
            <span class="label">业务员</span>
            <Select placeholder="请选择" v-model="salesmanId" clearable filterable>
              <Option v-for="(item, i) in userList" :key="i" :value="item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
              </Option>
            </Select>
          </div>
          <div class="btn-item btn-box">
            <Button type="primary" @click="searchAjax">查询</Button>
          </div>            
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0 || row.isSus == 1 }"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detailsPage(row)">详情</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <div>
      <Button class="btn" @click="back('/financialManage/groupFinanceSettlement')" v-if="step == 2">返回</Button>
      <Button class="btn" @click="backOperate" v-if="detailData.settlementStatus == 0">上一步</Button>
      <Button class="btn" @click="settledStep" v-if="detailData.settlementStatus == 1">上一步</Button>
      <Button class="btn" @click="exportReport">导出报表</Button>
      <Button type="primary" class="btn" @click="settlement" v-if="detailData.settlementStatus == 0">结算</Button>
      <Button type="primary" class="btn" v-else @click="resettlement">撤回结算</Button>
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
export default {
  mixins: [common, pageTool],
  props: {
    backData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      reportId: null,
      reportName: '',
      settlementDate: '',
      statisticsObj: {},
      detailData: {},
      tabVal: '1',
      tableData: [],
      userList: [],
      salesmanId: '',
      total: 0,
      step: null,
      columns: [],
      columns1: [
        {
          title: '业务员',
          align: 'center',
          minWidth: 130,
          slot: 'userName_staffNo'
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '批单数',
          align: 'center',
          key: 'billNum',
          minWidth: 100
        },
        {
          title: '保费合计',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '投保保费',
          align: 'center',
          key: 'insureFee',
          minWidth: 100
        },
        {
          title: '批改保费',
          align: 'center',
          key: 'billFee',
          minWidth: 100,
          render(h, params) {
            return (
              <div>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <span style={{ color: '#236dff', cursor: 'pointer' }}>{Number(params.row.billFeeAdd) + Number(params.row.billFeeSub)}</span>
                  <div slot="content">
                    <p>
                      批加：{params.row.billFeeAdd}元、批减：{params.row.billFeeSub}元
                    </p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '退保保费',
          align: 'center',
          key: 'refundFee',
          minWidth: 100
        },
        {
          title: '基础费用合计',
          align: 'center',
          key: 'baseLeaderAmount',
          minWidth: 100,
          render(h, params) {
            let baseFirstIncome = params.row.baseFirstIncome;
            let baseFirstLeaderIncome = params.row.baseFirstLeaderIncome;
            return <span>{(Number(baseFirstIncome) + Number(baseFirstLeaderIncome)).toFixed(2)}</span>;
          }
        },
        {
          title: '业务员基础费用合计',
          align: 'center',
          key: 'baseFirstIncome',
          minWidth: 130
        },
        {
          title: '团队长管理费合计',
          align: 'center',
          key: 'baseFirstLeaderIncome',
          minWidth: 120
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 200
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80,
          fixed: 'right'
        }
      ],
      columns2: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '人数',
          align: 'center',
          key: 'userNum',
          minWidth: 200
        },
        {
          title: '保费合计',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '投保保费',
          align: 'center',
          key: 'insureFee',
          minWidth: 100
        },
        {
          title: '批改保费',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            return (
              <div>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <span style={{ color: '#236dff', cursor: 'pointer' }}>{Number(params.row.billFeeAdd) + Number(params.row.billFeeSub)}</span>
                  <div slot="content">
                    <p>
                      批加：{params.row.billFeeAdd}元、批减：{params.row.billFeeSub}元
                    </p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '退保保费',
          align: 'center',
          key: 'refundFee',
          minWidth: 100
        },
        {
          title: '基础费用合计',
          align: 'center',
          key: 'baseLeaderAmount',
          minWidth: 100,
          render(h, params) {
            let baseFirstIncome = params.row.baseFirstIncome;
            let baseFirstLeaderIncome = params.row.baseFirstLeaderIncome;
            return <span>{(Number(baseFirstIncome) + Number(baseFirstLeaderIncome)).toFixed(2)}</span>;
          }
        },
        {
          title: '业务员基础费用合计',
          align: 'center',
          key: 'baseFirstIncome',
          minWidth: 130
        },
        {
          title: '团队长管理费合计',
          align: 'center',
          key: 'baseFirstLeaderIncome',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    const { reportId, settlementDate, reportName, step } = this.$route.query;
    this.reportId = reportId;
    this.reportName = reportName;
    this.settlementDate = settlementDate;
    this.step = step;
    this.getUserList();
  },
  activated() {
    if (this.reportId) {
      this.clickTabs(this.tabVal);
    }
  },
  methods: {
    setData() {
      const { reportId, settlementDate, reportName } = this.backData;
      this.reportId = reportId;
      this.reportName = reportName;
      this.settlementDate = settlementDate;
      this.clickTabs(this.tabVal);
      this.getUserList();
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
    },

    clickTabs(value) {
      if (value == 1) {
        this.columns = this.columns1;
      } else {
        this.salesmanId = null;
        this.columns = this.columns2;
      }
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
      this.getDetailData();
    },

    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: []
        }
      }).then(res => {
        this.userList = res.data;
      });
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/userSettlementReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.detailData = res.data;
      });
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: '/buz/userSettlementDetail/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId,
          userId: this.salesmanId
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/userSettlementDetail/read/page',
        type: 'POST',
        data: {
          reportId: this.reportId,
          groupType: this.tabVal,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          userId: this.salesmanId
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    //  详情
    detailsPage(row) {
      this.openPageTabTags('/financialManage/groupFinanceSettlement/detail', {
        reportId: this.reportId,
        tabVal: this.tabVal,
        orgId: row.orgId,
        userId: row.userId
      });
    },

    // 上一步
    backOperate() {
      if(!this.$units.pointAction('offline_81_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$http({
        url: '/buz/userSettlementDetail/rollback',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('backPage', { reportId: this.reportId, isAdd: 0, settled: false });
      });
    },

    // 已结算上一步
    settledStep() {
      this.$emit('settledStep', { reportId: this.reportId, isAdd: 0, settled: true });
    },

    // 导出
    exportReport() {
      if(!this.$units.pointAction('offline_81_3_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$units.downloadFile('/buz/userSettlementDetail/export', { reportId: this.reportId }, 'POST');
    },

    // 结算
    settlement() {
      if(!this.$units.pointAction('offline_81_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$notice.inquiry('您确定结算吗?').then(() => {
        this.$http({
          url: '/buz/userSettlementReport/settlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getDetailData();
          this.$notice.success('结算成功');
        });
      });
    },

    // 撤回结算
    resettlement() {
      if(!this.$units.pointAction('offline_81_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if (this.detailData.releaseStatus == '1') {
        this.$http({
          url: '/buz/userSettlementReport/resettlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getDetailData();
          this.$notice.success('撤回成功');
        });
      } else {
        this.$notice.inquiry('您确定撤回结算吗?').then(() => {
          this.$http({
            url: '/buz/userSettlementReport/resettlement',
            type: 'POST',
            data: {
              id: this.reportId
            }
          }).then(res => {
            this.getDetailData();
            this.$notice.success('撤回成功');
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-top-title {
  display: flex;
  font-size: 15px;
  .title {
    font-size: 16px;
    color: #3c464f;
    font-weight: bold;
  }
  .page-top-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    .item {
      color: #515c6f;
      font-size: 14px;
      margin-left: 20px;
    }
    .settlement-status {
      margin-top: 1px;
      margin-left: 20px;
      display: flex;
      .tag-settled {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 2px;
        font-size: 13px;
        color: #e3461f;
        border: 1px solid #ffc1b2;
        background: #fff5f2;
      }
      .tag-be {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        font-size: 13px;
        color: #35BF3F;
        border: 1px solid #ABEAAE;
        background: #F6FCF4;
      }
    }
  }
}
.statistics-container {
  margin-top: 20px;
  display: flex;
  p {
    white-space: nowrap;
  }
  .statistics-item {
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .item {
      margin-left: 60px;
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 10px;

      .num {
        color: #ff7134;
      }
    }
  }
}
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);
  &.red {
    background: #e3461f;
  }
  &.orange {
    background: #ff9900 !important;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
